module.exports = __webpack_public_path__ + "static/media/Logo.bc63a685.svg";